import { useState } from 'react';
import Icon from '../../../components/AppIcon';
import QuestionCard from './QuestionCard';

const ExperienceLevelStep = ({ formData, onUpdate }) => {
  const [selectedLevel, setSelectedLevel] = useState(formData?.experienceLevel || '');

  const experienceLevels = [
    {
      id: 'certified',
      value: 'certified',
      label: 'معتمد',
      description: 'مصور معتمد مع خبرة جيدة وجودة مضمونة',
      icon: 'BadgeCheck',
      iconColor: '#22c55e', // Green
      iconBg: 'bg-green-50',
      borderColor: 'hover:border-green-400',
      selectedBorder: 'border-green-500 bg-green-50/50',
      features: ['أسعار مناسبة', 'جودة مضمونة', 'خدمة موثوقة']
    },
    {
      id: 'distinguished',
      value: 'distinguished',
      label: 'مميز',
      description: 'مصور متميز بمعرض أعمال احترافي',
      icon: 'Star',
      iconColor: '#eab308', // Gold
      iconBg: 'bg-amber-50',
      borderColor: 'hover:border-amber-400',
      selectedBorder: 'border-amber-500 bg-amber-50/50',
      features: ['خبرة متقدمة', 'جودة عالية', 'معدات احترافية'],
      recommended: true
    },
    {
      id: 'elite',
      value: 'elite',
      label: 'نخبة',
      description: 'مصور من النخبة بخبرة استثنائية',
      icon: 'Crown',
      iconColor: '#7c3aed', // Purple
      iconBg: 'bg-blue-50',
      borderColor: 'hover:border-blue-400',
      selectedBorder: 'border-blue-500 bg-blue-50/50',
      features: ['خبرة واسعة', 'جودة استثنائية', 'خدمة VIP']
    }
  ];

  const handleLevelChange = (levelId, label) => {
    setSelectedLevel(levelId);
    const selectedLevelObj = experienceLevels.find(l => l.value === levelId);
    onUpdate({ 
      experienceLevel: levelId,
      experienceLevelLabel: label || selectedLevelObj?.label || levelId
    });
  };

  return (
    <QuestionCard
      icon="Award"
      title="ما مستوى خبرة المصور المطلوب؟"
      description="مستوى الخبرة يؤثر على التسعير النهائي المحسوب ديناميكياً"
    >
      <div className="grid grid-cols-1 gap-4">
        {experienceLevels?.map((level) => {
          const isSelected = formData?.experienceLevel === level?.value;
          
          return (
            <button
              key={level?.value}
              onClick={() => handleLevelChange(level?.value, level?.label)}
              className={`relative p-5 rounded-2xl border-2 text-right transition-all duration-200 ${
                isSelected
                  ? level.selectedBorder + ' shadow-md'
                  : `border-slate-200 bg-white ${level.borderColor} hover:shadow-sm`
              }`}
            >
              {/* Recommended Badge */}
              {level?.recommended && (
                <div className="absolute -top-3 left-4">
                  <span className="px-3 py-1 text-xs font-bold bg-gradient-to-r from-amber-400 to-orange-400 text-white rounded-full shadow-sm">
                    ⭐ موصى به
                  </span>
                </div>
              )}

              <div className="flex items-start gap-4">
                {/* Icon */}
                <div className={`w-14 h-14 rounded-xl ${level.iconBg} flex items-center justify-center flex-shrink-0 transition-transform ${isSelected ? 'scale-110' : ''}`}>
                  <Icon name={level.icon} size={28} color={level.iconColor} fill={level.value === 'distinguished' ? level.iconColor : 'none'} />
                </div>

                {/* Content */}
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1">
                    <h3 className="text-lg font-bold text-slate-900">
                      {level?.label}
                    </h3>
                  </div>
                  
                  <p className="text-sm text-slate-500 mb-3">
                    {level?.description}
                  </p>

                  {/* Features */}
                  <div className="flex flex-wrap gap-2">
                    {level?.features?.map((feature, i) => (
                      <span 
                        key={i} 
                        className="px-2.5 py-1 text-xs font-medium bg-slate-100 text-slate-600 rounded-lg"
                      >
                        {feature}
                      </span>
                    ))}
                  </div>
                </div>

                {/* Selection Indicator */}
                <div className={`w-6 h-6 rounded-full border-2 flex items-center justify-center flex-shrink-0 transition-all ${
                  isSelected 
                    ? 'border-transparent bg-gradient-to-br from-primary to-primary/80' 
                    : 'border-slate-300'
                }`}>
                  {isSelected && (
                    <Icon name="Check" size={14} color="white" />
                  )}
                </div>
              </div>
            </button>
          );
        })}
      </div>
    </QuestionCard>
  );
};

export default ExperienceLevelStep;
